const categories = [
  {
    id: "pasta-grains",
    name: "Pasta & Grains",
    shortName: "Pasta",
    path: "/shop?category=pasta-grains",
    description:
      "Small-batch pasta, risotto rice, and comforting pantry grains.",
  },
  {
    id: "tomatoes-sauces",
    name: "Tomatoes & Sauces",
    shortName: "Sauces",
    path: "/shop?category=tomatoes-sauces",
    description: "Bright tomato preserves and ready-to-serve Italian sauces.",
  },
  {
    id: "olive-oil-vinegar",
    name: "Olive Oil & Vinegar",
    shortName: "Oil & Vinegar",
    path: "/shop?category=olive-oil-vinegar",
    description: "Fragrant oils and balanced vinegars for the everyday table.",
  },
  {
    id: "herbs-antipasti",
    name: "Herbs & Antipasti",
    shortName: "Antipasti",
    path: "/shop?category=herbs-antipasti",
    description: "Savory jars, salts, and seasonings for effortless aperitivo.",
  },
  {
    id: "sweets-preserves",
    name: "Sweets & Preserves",
    shortName: "Sweets",
    path: "/shop?category=sweets-preserves",
    description:
      "Biscuits, confections, and fruit preserves for a sweet finish.",
  },
  {
    id: "coffee-tea",
    name: "Coffee & Tea",
    shortName: "Coffee & Tea",
    path: "/shop?category=coffee-tea",
    description: "Italian-style coffee and gentle botanical infusions.",
  },
];

const siteConfig = {
  brandName: "guyspruce",
  logo: {
    type: "image",
    value: "GUYSPRUCE",
    monogram: "G",
    tagline: "Thoughtful pantry goods, gathered with care",
    imagePath: "/guyspruce-logo.svg",
  },
  logoText: "GUYSPRUCE",
  logoPath: "/guyspruce-logo.svg",
  description:
    "A warm, modern pantry bringing thoughtful staples, celebratory sweets, and everyday table rituals together.",
  contact: {
    email: "shift@guyspruce.work",
    address: "1715 West Farms Road, Bronx, NY 10460, United States",
    hours: "Monday–Friday, Eastern Time",
    customerCareHours: "Monday–Friday, Eastern Time",
  },
  address: {
    name: "guyspruce Warehouse + Office",
    street: "1715 West Farms Road",
    city: "Bronx",
    region: "NY",
    postalCode: "10460",
    country: "United States",
    formatted: "1715 West Farms Road, Bronx, NY 10460, United States",
  },
  shipping: {
    currency: "USD",
    currencySymbol: "$",
    freeThreshold: null,
    flatRate: 9.99,
    perAdditionalItem: 0,
    maximumCharge: 9.99,
    processingTime: "1–2 business days",
    deliveryWindow: "1–6 business days after dispatch",
    freeShippingThreshold: null,
    standard: {
      label: "Standard shipping",
      price: 9.99,
      estimatedBusinessDays: "1–6",
    },
    express: {
      label: "Express shipping",
      price: 24,
      estimatedBusinessDays: "1–2",
    },
    perishableNotice:
      "Heat-sensitive items may ship with protective packaging or be held over a weekend.",
  },
  returns: {
    guarantee: "100% satisfaction guarantee",
    email: "shift@guyspruce.work",
  },
  promotions: [
    {
      code: "PANTRY10",
      label: "10% pantry welcome offer",
      type: "percentage",
      value: 10,
      minimumSubtotal: 50,
    },
  ],
  checkout: {
    orderNumberPrefix: "GUS",
    lastOrderStorageKey: "guyspruceLastOrder",
    confirmationLifetimeMinutes: 30,
  },
  announcement: "$9.99 standard shipping",
  navigation: [
    { id: "home", label: "Home", path: "/" },
    { id: "shop", label: "Shop", path: "/shop" },
    { id: "gifts", label: "Gifts", path: "/gifts" },
    { id: "recipes", label: "Recipes", path: "/recipes" },
    { id: "new", label: "New Arrivals", path: "/shop?collection=new-arrivals" },
    {
      id: "bestsellers",
      label: "Best Sellers",
      path: "/shop?collection=best-sellers",
    },
    { id: "about", label: "Our Story", path: "/about" },
    { id: "contact", label: "Contact", path: "/contact" },
  ],
  editorialNavigation: [
    { id: "journal", label: "Journal", path: "/journal" },
    { id: "wholesale", label: "Wholesale", path: "/wholesale" },
    { id: "corporate-gifts", label: "Corporate gifts", path: "/gifts" },
    { id: "recipe-index", label: "Recipes", path: "/recipes" },
  ],
  categories,
  legalNavigation: [
    { id: "faq", label: "FAQ", path: "/faq" },
    { id: "shipping", label: "Shipping", path: "/shipping" },
    { id: "returns", label: "Returns", path: "/returns" },
    { id: "privacy", label: "Privacy", path: "/privacy" },
    { id: "cookies", label: "Cookie policy", path: "/cookies" },
    { id: "terms", label: "Terms", path: "/terms" },
  ],
};

export { categories };
export default siteConfig;
